import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Theme,
} from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import QuillLocalStorage from 'core/utils/localStorageClient';
import Track from '@Common/handlers/track';
import { CloseOutlined } from '@mui/icons-material';
import { openToastr } from '@Common/handlers/services';

const useStyles = makeStyles((theme: Theme) => ({
  termsMainContainers: {
    maxWidth: '1000px',
    margin: 'auto',
    paddingBottom: '25px',
  },
  policyUpdate: {
    color: theme.palette.text.primary,
    padding: '16px 8px',
    backgroundColor: theme.specialColors.CIRCULAR_PROGRESS,
    borderRadius: '8px',
  },
}));
function PrivacyPageDE() {
  const classes = useStyles();
  //   const [shortLink,setShortLink] = useState('')
  //   const [repeat,setRepeat] = useState(false)

  /*   useEffect(() => {
    Track.visitedPage('privacy');
  }, []); */
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    Track.trackingDisabled();
    QuillLocalStorage.getInstance().set('userTrackingAllowed', 'false');
    setShowModal(false);
    openToastr('Please refresh the page to view changes.');
  };

  return (
    <div className="container">
      <div className={`${classes.termsMainContainers} terms-main-container`}>
        <Grid container justifyContent="center" className="page-header">
          <h1 className="pageTitle">
            QuillBot
            <br />
            Datenschutzbestimmungen
          </h1>
        </Grid>

        <div className="terms-total-container qbp-pt20" style={{ textAlign: 'justify' }}>
          <div className={classes.policyUpdate}>
            <h3 style={{ margin: '0 0 16px 0' }}>
              <u>AKTUALISIERUNGEN DER DATENSCHUTZRICHTLINIE</u>
            </h3>
            <p style={{ margin: 0 }}>
              Wir bei QuillBot nehmen Ihre Privatsphäre ernst und möchten Sie darüber informieren,
              dass wir unsere Datenschutzrichtlinie aktualisiert haben, um die persönlichen Daten zu
              beschreiben, die wir sammeln, wenn Sie das neue QuillBot für Chrome-Erweiterung
              verwenden. Die Erweiterung ist in Chrome integriert, so dass Sie den Text, den Sie
              paraphrasieren oder korrigieren möchten, nicht mehr auswählen und in die
              QuillBot-Seitenleiste eingeben müssen.{' '}
              <span style={{ fontWeight: 600 }}>
                Bitte lesen Sie den neuen Absatz mit dem Titel „Ihr Inhalt“ in Abschnitt B,
                „Informationen, die wir sammeln, wenn Sie unsere Dienste nutzen“ für weitere
                Details.
              </span>
            </p>
          </div>

          <p> Gültig ab 1. März 2022</p>

          <p>
            QuillBot (Course Hero), LLC (<b>„QuillBot“</b>, <b>„wir“</b>, <b>„unser</b>“ und/oder{' '}
            <b>„uns</b>“) schätzt die Privatsphäre von Personen, die unsere Website
            (https://www.quillbot.com) oder Dienste, die auf diese Datenschutzrichtlinie verweisen
            (zusammen unsere <b>„Dienste“</b>), nutzen. Diese Datenschutzrichtlinie (die{' '}
            <b>„Datenschutzrichtlinie“</b>) erläutert, wie wir persönliche Daten von Nutzern unserer
            Dienste erfassen, verwenden und weitergeben. Im Sinne dieser Datenschutzrichtlinie
            bezeichnet der Begriff „Persönliche Daten“ alle Informationen, die sich auf eine
            identifizierte oder identifizierbare Person beziehen. Durch die Nutzung unserer Dienste
            erklären Sie sich mit der Erfassung, Verwendung und Offenlegung Ihrer persönlichen Daten
            wie in dieser Datenschutzrichtlinie beschrieben einverstanden. Neben dieser
            Datenschutzrichtlinie unterliegt Ihre Nutzung unserer Dienste auch unserenz{' '}
            <a href="/terms">Nutzungsbedingungen</a>. Wenn Sie in Kalifornien ansässig sind, finden
            Sie in unserem{' '}
            <a href="/ccpa">Datenschutzhinweis für in Kalifornien ansässige Personen</a> weitere
            Informationen über Ihre Datenschutzrechte in Kalifornien und darüber, wie Sie diese
            Rechte ausüben können.
          </p>
          <h3>
            <u>INFORMATIONEN, DIE WIR SAMMELN</u>
          </h3>
          <p>
            Wir können eine Vielzahl von Informationen von oder über Sie oder Ihre Geräte aus
            verschiedenen Quellen sammeln, wie unten beschrieben.
          </p>
          <ol type="A">
            <li>
              <p>
                <b>Informationen, die Sie uns zur Verfügung stellen</b>
                <p>
                  <b>Registrierung.</b> Wenn Sie sich für ein Konto zur Nutzung unserer Dienste
                  registrieren, fragen wir Sie nach Ihren persönlichen Daten, einschließlich Ihres
                  Namens, Ihrer E-Mail-Adresse und Ihres Passworts. Wenn Sie sich für die
                  Premium-Version unserer Dienste anmelden, fragen wir Sie nach weiteren
                  persönlichen Daten, wie im Abschnitt „Zahlungen“ unten beschrieben.
                </p>
                <p>
                  <b>Mitteilungen.</b> Wenn Sie uns direkt kontaktieren, können wir auch persönliche
                  Informationen über Sie erhalten. Wenn Sie uns zum Beispiel für weitere
                  Informationen über QuillBot oder für Support kontaktieren, erhalten wir Ihren
                  Namen, Ihre E-Mail-Adresse und den Inhalt Ihrer Nachricht an uns. Wenn Sie sich
                  für unseren Newsletter anmelden, erhalten wir Ihre E-Mail-Adresse. Wenn wir Ihnen
                  E-Mails schicken, können wir nachverfolgen, ob Sie diese öffnen, um zu erfahren,
                  wie wir unseren Kunden eine bessere Erfahrung bieten und unsere Dienstleistungen
                  verbessern können.
                </p>
                <p>
                  <b>Ihre Nutzung unserer Dienste.</b> Wenn Sie unsere Dienste nutzen, können wir
                  personenbezogene Daten erfassen, die Sie uns über unsere Dienste zur Verfügung
                  stellen oder anderweitig zugänglich machen. Wenn Sie zum Beispiel die
                  Plagiatsprüfung nutzen, speichern wir eine Kopie Ihres Dokuments, einschließlich
                  aller darin enthaltenen Informationen. Wenn Sie unser Paraphraser-Tool verwenden,
                  erfassen wir alle Informationen, die Sie paraphrasieren, einschließlich der
                  persönlichen Daten, die Sie in Paraphraser eingeben. Wenn Sie Dokumente auf unsere
                  Dienste hochladen, speichern wir sowohl eine Kopie des Originaldokuments als auch
                  die umgeschriebene Version und alle darin enthaltenen Informationen.
                </p>
                <p>
                  <b>Karriere.</b> Wenn Sie sich für eine Stelle bei uns bewerben möchten, können
                  Sie Ihre Kontaktinformationen und Ihren Lebenslauf online übermitteln. Wir
                  erfassen die personenbezogenen Daten, die Sie uns im Rahmen Ihrer Bewerbung zur
                  Verfügung stellen, wie z. B. Ihre Kontaktdaten, Informationen zu Ihrer aktuellen
                  Beschäftigung und andere Informationen, die Sie zusammen mit Ihrer Bewerbung und
                  Ihrem Lebenslauf übermitteln. Wenn Sie sich bei uns über eine Drittplattform (wie
                  Glassdoor oder LinkedIn) bewerben, erfassen wir alle Informationen, die Sie uns
                  über diese Drittplattformen zur Verfügung stellen.
                </p>
                <p>
                  <b>Zahlungen.</b> Wenn Sie eine Zahlung über unsere Dienste vornehmen, werden Ihre
                  Kreditkarteninformationen, Rechnungsinformationen und alle anderen finanziellen
                  Informationen, die für die Durchführung Ihrer Zahlung erforderlich sind („
                  <b>Zahlungsinformationen</b>“), von einem unserer Drittanbieter- Zahlungsabwickler
                  (Stripe, PayPal oder Google Pay) verarbeitet, und wir sammeln, speichern oder
                  verarbeiten Ihre Zahlungsinformationen nicht. Weitere Informationen finden Sie im
                  Abschnitt „Zahlungsabwicklung“ weiter unten.
                </p>
              </p>
            </li>

            <li>
              <p>
                <b>Informationen, die wir sammeln, wenn Sie unsere Dienste nutzen</b>
                <p>
                  <b>Standort-Informationen.</b> Wenn Sie unsere Dienste nutzen, können wir auf
                  allgemeine Informationen über Ihren Standort schließen. Zum Beispiel kann Ihre
                  IP-Adresse auf Ihre allgemeine geografische Region hinweisen.
                </p>
                <p>
                  <b>Geräte-Informationen.</b> Wir erhalten Informationen über das Gerät und die
                  Software, die Sie für den Zugriff auf unsere Dienste verwenden, einschließlich der
                  Internetprotokoll (IP)-Adresse, des Typs und der Version des Webbrowsers, der
                  Version des Betriebssystems, der Version von Microsoft Word und der
                  Gerätekennungen.
                </p>
                <p>
                  <b>Ihr Inhalt.</b> Wenn Sie das QuillBot für Chrome-Erweiterung verwenden, werden
                  die Inhalte in den von Ihnen vorbereiteten E- Mails (mit Ausnahme der Inhalte, die
                  Sie beantworten oder weiterleiten), in den von Ihnen geschriebenen
                  Chat-Nachrichten (mit Ausnahme des Verlaufs oder der empfangenen Chats), in den
                  von Ihnen erstellten Dokumenten, in den Suchanfragen und in den von Ihnen in
                  mehrzeilige Felder auf den von Ihnen besuchten Websites eingegebenen Texten („Ihre
                  Inhalte“), die von Ihnen in Verbindung mit der Nutzung unserer Erweiterung
                  übermittelt werden, in Echtzeit von unserem Algorithmus für maschinelles Lernen
                  verwendet. Wir sammeln auch URLs und Nutzungsinformationen (zusätzlich zu den oben
                  beschriebenen Nutzungsinformationen), wie z. B. die Anzahl der
                  Deaktivierung/Aktivierung der Erweiterung auf einer Website, die wir aufbewahren,
                  um zu verstehen, wie Sie diesen Dienst nutzen und um ihn zu verbessern. Wir
                  sammeln Ihre Inhalte nur, wenn das QuillBot-Symbol angezeigt und aktiviert ist,
                  was anzeigt, dass Ihre Inhalte grammatikalisch geprüft oder umschrieben werden.
                  Sie können die QuillBot-Erweiterung jederzeit in der oberen rechten Ecke Ihres
                  Browsers deaktivieren. Wir greifen nicht auf Ihre Kontakte, den Text in
                  einzeiligen Eingabefeldern (die mit größerer Wahrscheinlichkeit persönliche
                  Informationen enthalten) oder auf Inhalte in Feldern zu, die als „sensibel“
                  gekennzeichnet sind, wie z. B. Kreditkarten, Passwörter, E-Mail-Adressen oder
                  E-Mail-Betreff- Felder.
                </p>
                <p>
                  <b>Informationen über die Nutzung.</b> Um zu verstehen, wie Sie unsere Dienste
                  nutzen, und um sie zu verbessern, erhalten wir automatisch Informationen über Ihre
                  Interaktionen mit unseren Diensten, wie z. B. das Datum und die Uhrzeit der
                  Besuche, die aufgerufenen Seiten, Websites Dritter, auf denen Sie unsere Dienste
                  nutzen, Links zu/von einer Seite und die Dauer einer Sitzung.
                </p>
                <p>
                  <b>Analyse-Partner.</b> Wir verwenden Analysedienste wie Google Analytics und
                  Amplitude, um bestimmte Analysedaten zu sammeln und zu verarbeiten. Diese Dienste
                  können auch Informationen über Ihre Nutzung anderer Websites, Anwendungen und
                  Online- Ressourcen erfassen. Sie können sich unter
                  <a
                    href="https://www.google.com/policies/privacy/partners/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {' '}
                    https://www.google.com/policies/privacy/partners/{' '}
                  </a>{' '}
                  über die Praktiken von Google informieren und diese deaktivieren, indem Sie das
                  Browser-Add-on zur Deaktivierung von Google Analytics herunterladen, das unter
                  <a
                    href="https://tools.google.com/dlpage/gaoptout"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {' '}
                    https://tools.google.com/dlpage/gaoptout
                  </a>{' '}
                  verfügbar ist.
                </p>
                <p>
                  <b>Cookies und ähnliche Technologien.</b> Wir und unsere Drittpartner können
                  persönliche Informationen mithilfe von Cookies sammeln. Cookies sind kleine
                  Dateien mit Buchstaben und Zahlen, die wir in Ihrem Browser oder auf der
                  Festplatte Ihres Computers speichern. Sie enthalten Informationen, die auf die
                  Festplatte Ihres Computers übertragen werden. Wir verwenden Cookies, Beacons,
                  unsichtbare Tags und ähnliche Technologien (zusammenfassend <b>„Cookies“</b>), um
                  Informationen über Ihre Browsing-Aktivitäten zu sammeln und Sie von anderen
                  Benutzern unserer Dienste zu unterscheiden. Dies hilft Ihnen bei der Nutzung
                  unserer Dienste und ermöglicht es uns außerdem, die Funktionalität unserer Dienste
                  zu verbessern. Cookies können für das Leistungsmanagement verwendet werden, um
                  Informationen darüber zu sammeln, wie unsere Dienste zu Analysezwecken genutzt
                  werden. Sie können auch für die Verwaltung von Funktionen verwendet werden, die es
                  uns ermöglichen, den Besuch des Nutzers effizienter zu gestalten, indem sie sich
                  beispielsweise Spracheinstellungen, Passwörter und Anmeldedaten merken. Wir können
                  auch Pixel-Tags und Web- Beacons in unseren Diensten verwenden. Dabei handelt es
                  sich um winzige Grafiken, die auf Webseiten oder in unseren E-Mails platziert
                  werden und es uns ermöglichen festzustellen, ob Sie eine bestimmte Aktion
                  durchgeführt haben. Im Folgenden finden Sie eine Übersicht über die Arten von
                  Cookies, die wir und Dritte zur Erfassung persönlicher Daten verwenden können.
                </p>
                <ul style={{ listStyleType: 'disc' }}>
                  <li>
                    <p>
                      <b>Streng notwendige Cookies.</b> Einige Cookies sind unbedingt erforderlich,
                      um Ihnen unsere Dienste zur Verfügung zu stellen. Ohne diese Art von Cookies
                      können wir Ihnen unsere Dienste nicht zur Verfügung stellen.
                    </p>
                  </li>

                  <li>
                    <p>
                      <b>Funktionale Cookies.</b> Funktionale Cookies werden verwendet, um Sie zu
                      erkennen, wenn Sie zu unseren Diensten zurückkehren. Dadurch können wir unsere
                      Inhalte für Sie anpassen und Ihre Präferenzen speichern. Zum Beispiel
                      verwenden wir funktionale Cookies, um uns Ihre Wahl der Sprache oder Region zu
                      merken.
                    </p>
                  </li>

                  <li>
                    <p>
                      <b>Analytische oder Leistungscookies.</b> Wir verwenden Cookies auch für
                      Website- und App-Analysezwecke, um unsere Dienste zu betreiben, zu warten und
                      zu verbessern. Wir können unsere eigenen Analyse-Cookies verwenden oder
                      Drittanbieter wie Google Analytics, Amplitude, Inspectlet und Klaviyo nutzen,
                      um bestimmte Analysedaten in unserem Namen zu sammeln und zu verarbeiten.
                      Diese Anbieter können auch Informationen über Ihre Nutzung anderer Websites,
                      Anwendungen und Online-Ressourcen erfassen. Sie können Google Analytics,
                      Amplitude, Inspectlet und Klaviyo deaktivieren, ohne dass sich dies auf Ihren
                      Besuch unserer Dienste auswirkt,
                      <a
                        onClick={() => {
                          setShowModal(true);
                        }}
                        role="button"
                        style={{ cursor: 'pointer' }}
                        onKeyDown={() => {
                          setShowModal(true);
                        }}
                        tabIndex={0}
                      >
                        {' '}
                        indem Sie hier klicken
                      </a>
                      .
                    </p>
                  </li>
                </ul>
                Wo dies gesetzlich vorgeschrieben ist, holen wir Ihre Zustimmung zur Verwendung von
                Cookies ein. Weitere Informationen über Ihre Rechte und Wahlmöglichkeiten sowie
                darüber, wie Sie die Verwendung bestimmter Cookies blockieren können, finden Sie im
                Abschnitt Ihre Rechte und Wahlmöglichkeiten weiter unten.
              </p>
            </li>
            <li>
              <p>
                <b>Informationen, die wir von Drittparteien erhalten</b>
                <p>
                  <b>Plattform-Anmeldung.</b> Wenn Sie sich über ein Konto eines Drittanbieters, wie
                  z. B. Ihr Google- oder Facebook-Konto, bei unseren Diensten anmelden, erhalten wir
                  Ihre persönlichen Daten, einschließlich Ihres Benutzernamens, Ihres Namens und
                  Ihrer E-Mail- Adresse.
                </p>
                <p>
                  <b>Partner.</b> Es kann sein, dass wir persönliche Informationen über Sie von
                  Dritten erhalten, wie z. B. von Daten- oder Marketingpartnern, und diese mit
                  anderen Informationen, die wir über Sie haben, kombinieren.
                </p>
              </p>
            </li>

            <li>
              <p>
                <b>Zahlungsabwicklung</b>
                <p>
                  Wenn Sie über unsere Dienste Einkäufe tätigen, wird Ihre Zahlung von einem
                  externen Zahlungsabwickler (<b>„Zahlungsabwickler“</b>) verarbeitet. Dieser
                  Zahlungsabwickler kann persönliche Daten von Ihnen erfassen, einschließlich Ihres
                  Namens, Ihrer E-Mail-Adresse und Ihrer Rechnungsadresse. Die Verwendung Ihrer
                  persönlichen Daten durch den Zahlungsabwickler unterliegt dessen
                  Geschäftsbedingungen und Datenschutzrichtlinien, und die Informationen, die wir
                  von unserem Zahlungsabwickler über Sie erhalten, unterliegen diesen
                  Datenschutzrichtlinien.
                </p>
              </p>
            </li>
          </ol>
          <h3>
            <u>WIE WIR DIE VON UNS GESAMMELTEN INFORMATIONEN VERWENDEN</u>
          </h3>
          <p>
            Wir verwenden die von uns gesammelten persönlichen Daten:
            <ul style={{ listStyleType: 'disc' }}>
              <li>
                Zur Bereitstellung, Wartung, Fehlersuche, Verbesserung und Erweiterung unserer
                Dienste;
              </li>
              <li>
                Um zu verstehen und zu analysieren, wie Sie unsere Dienste nutzen, und um neue
                Produkte, Dienste, Merkmale und Funktionalitäten zu entwickeln;
              </li>
              <li>Zum Verstehen und Analysieren von Nutzungsmustern;</li>
              <li>Um Ihre Bewerbung zu bearbeiten;</li>
              <li>Zur Kontaktaufnahme mit potenziellen Kunden über soziale Medien und E-Mail;</li>
              <li>In de-identifizierter und aggregierter Form, um unsere Dienste zu verbessern;</li>
              <li>
                Um mit Ihnen zu kommunizieren, Ihnen Aktualisierungen und andere Informationen zu
                unseren Diensten zukommen zu lassen, von Ihnen angeforderte Informationen
                bereitzustellen, auf Kommentare und Fragen zu antworten und anderweitig
                Kundensupport zu leisten;
              </li>
              <li>
                Zur Aufdeckung und Vorbeugung von Betrug und Reaktion auf Vertrauens- und
                Sicherheitsprobleme, die auftreten können;{' '}
              </li>
              <li>
                Zu Zwecken der Einhaltung von Vorschriften, einschließlich der Durchsetzung unserer
                Nutzungsbedingungen oder anderer gesetzlicher Rechte, oder wenn dies durch geltende
                Gesetze und Vorschriften erforderlich ist oder von einem Gericht oder einer
                Regierungsbehörde verlangt wird; und
              </li>
              <li>
                Für andere Zwecke, über die wir zum Zeitpunkt der Erfassung der personenbezogenen
                Daten ausdrücklich informieren.
              </li>
            </ul>
          </p>
          <h3>
            <u>RECHTSGRUNDLAGEN FÜR DIE VERARBEITUNG EUROPÄISCHER INFORMATIONEN</u>
          </h3>
          <p>
            Wenn Sie sich im Europäischen Wirtschaftsraum (<b>„EWR“</b>) oder im Vereinigten
            Königreich (<b>„UK“</b>) befinden, verarbeiten wir Ihre personenbezogenen Daten nur,
            wenn wir eine gültige Rechtsgrundlage für diese Verarbeitung haben, einschließlich der
            unten aufgeführten.
            <ul style={{ listStyleType: 'disc' }}>
              <li>
                <p>
                  <b>Einverständnis.</b> Sie haben in die Verwendung Ihrer persönlichen Daten
                  eingewilligt. Beispielsweise können wir Ihre personenbezogenen Daten verarbeiten,
                  um Ihnen Marketingmitteilungen zu senden oder Cookies zu verwenden, wenn Sie einer
                  solchen Verwendung zugestimmt haben.
                </p>
              </li>

              <li>
                <p>
                  <b>Vertragliche Notwendigkeit.</b> Wir benötigen Ihre persönlichen Daten, um Ihnen
                  unsere Dienste zur Verfügung zu stellen. Zum Beispiel müssen wir Ihre persönlichen
                  Daten verarbeiten, um Ihre Anfragen zu beantworten.
                </p>
              </li>

              <li>
                <p>
                  <b>Einhaltung einer gesetzlichen Verpflichtung.</b> Wir sind gesetzlich
                  verpflichtet, Ihre persönlichen Daten zu verwenden. Zum Beispiel können wir Ihre
                  persönlichen Daten verarbeiten, um steuerlichen und buchhalterischen
                  Verpflichtungen nachzukommen.
                </p>
              </li>

              <li>
                <p>
                  <b>Berechtigte Interessen.</b> Wir oder ein Dritter haben ein berechtigtes
                  Interesse an der Verwendung Ihrer persönlichen Daten. Insbesondere haben wir ein
                  berechtigtes Interesse daran, Ihre personenbezogenen Daten für die
                  Produktentwicklung und interne Analysezwecke zu verwenden und ansonsten die
                  Sicherheit und Leistung unserer Dienste zu verbessern. Wir berufen uns nur dann
                  auf unsere berechtigten Interessen oder die eines Dritten, um Ihre
                  personenbezogenen Daten zu verarbeiten, wenn diese Interessen nicht durch Ihre
                  Rechte und Interessen überlagert werden.
                </p>
              </li>
            </ul>
          </p>
          <h3>
            <u>WIE WIR DIE VON UNS GESAMMELTEN INFORMATIONEN WEITERGEBEN</u>
          </h3>
          <p>
            <p>
              Wir geben die von Ihnen gesammelten persönlichen Daten nicht weiter oder legen sie auf
              andere Weise offen, außer wie unten beschrieben oder wie es Ihnen zum Zeitpunkt der
              Sammlung mitgeteilt wurde.
            </p>
            <p>
              <b>Verbundene Unternehmen.</b> Wir können alle Informationen, die wir erhalten, zu den
              in dieser Datenschutzrichtlinie beschriebenen Zwecken an unsere verbundenen
              Unternehmen weitergeben.
            </p>
            <p>
              <b>Anbieter und Dienstanbieter.</b> Wir können alle Informationen, die wir erhalten,
              an Anbieter und Dienstleister weitergeben, die wir im Zusammenhang mit der
              Bereitstellung unserer Dienste beauftragt haben.
            </p>
            <p>
              <b>Vermarktung.</b> Wir vermieten, verkaufen oder teilen Ihre persönlichen Daten nicht
              mit nicht angeschlossenen Unternehmen für deren Direktmarketingzwecke, es sei denn,
              wir haben Ihre Erlaubnis.
            </p>
            <p>
              <b>Werbepartner.</b> Wir arbeiten möglicherweise mit externen Werbepartnern zusammen,
              um Ihnen Werbung zu zeigen, die Sie unserer Meinung nach interessieren könnte. Einige
              unserer Werbepartner sind Mitglieder der Network Advertising Initiative (
              <a
                href="http://optout.networkadvertising.org/?c=1#!/"
                rel="noopener noreferrer"
                target="_blank"
              >
                http://optout.networkadvertising.org/?c=1#!/
              </a>
              ) oder der Digital Advertising Alliance (
              <a
                href="http://optout.aboutads.info/?c=2&lang=EN"
                rel="noopener noreferrer"
                target="_blank"
              >
                http://optout.aboutads.info/?c=2&lang=EN
              </a>
              ). Wenn Sie keine personalisierte Werbung erhalten möchten, besuchen Sie bitte die
              entsprechenden Seiten, um zu erfahren, wie Sie den Erhalt von webbasierter
              personalisierter Werbung von Mitgliedsunternehmen ablehnen können. Sie können auf die
              Einstellungen Ihres mobilen Betriebssystems zugreifen, um die Verfolgung von Anzeigen
              einzuschränken, oder Sie können die AppChoices-Mobilanwendung installieren, um mehr
              darüber zu erfahren, wie Sie personalisierte Anzeigen in mobilen Anwendungen ablehnen
              können.
            </p>
            <p>
              <b>Gesetzlich vorgeschriebene und ähnliche Offenlegungen.</b> Wir können auf Ihre
              persönlichen Daten zugreifen, sie aufbewahren und offenlegen, wenn wir glauben, dass
              dies erforderlich oder angemessen ist, um: (i) um Anfragen der
              Strafverfolgungsbehörden und rechtlichen Verfahren, wie z. B. Gerichtsbeschlüssen oder
              Vorladungen, nachzukommen; (ii) um auf Ihre Anfragen zu reagieren; oder (iii) um Ihre,
              unsere oder die Rechte, das Eigentum oder die Sicherheit anderer zu schützen.
            </p>
            <p>
              <b>Fusionen, Verkäufe oder andere Vermögensübertragungen.</b> Wir können Ihre
              persönlichen Daten an Dienstleister, Berater, potenzielle Transaktionspartner oder
              andere Dritte im Zusammenhang mit der Erwägung, Verhandlung oder dem Abschluss einer
              Unternehmenstransaktion, bei der wir von einem anderen Unternehmen übernommen werden
              oder mit diesem fusionieren oder bei der wir unser gesamtes Geschäft oder einen Teil
              unseres Vermögens verkaufen, liquidieren oder übertragen, weitergeben.
            </p>
            <p>
              <b>Einverständnis.</b> Wir können Ihre persönlichen Daten auch mit Ihrer Zustimmung
              weitergeben.
            </p>
          </p>
          <h3>
            <u>IHRE RECHTE UND WAHLMÖGLICHKEITEN</u>
          </h3>
          <p>
            <p>
              <b>Marketing-Kommunikation.</b> Sie können sich von unseren Werbe-E-Mails über den in
              den E-Mails angegebenen Link abmelden. Auch wenn Sie den Erhalt von Werbenachrichten
              von uns abbestellen, erhalten Sie weiterhin Verwaltungsnachrichten von uns.
            </p>
            <p>
              {' '}
              <b>Nicht verfolgen.</b> Es gibt keinen anerkannten Standard, wie auf Do Not
              Track-Signale zu reagieren ist, und wir reagieren nicht auf solche Signale.
              <p>
                Wenn Sie sich dafür entscheiden, uns die von uns erfassten persönlichen Daten nicht
                zur Verfügung zu stellen, funktionieren einige Funktionen unserer Dienste
                möglicherweise nicht wie vorgesehen.
              </p>
            </p>
            <p>
              <b>Wie man Cookies blockiert.</b> Sie können Cookies blockieren, indem Sie Ihren
              Internetbrowser so einstellen, dass er einige oder alle Cookies blockiert. Wenn Sie
              jedoch Ihren Browser so einstellen, dass alle Cookies (einschließlich wesentlicher
              Cookies) blockiert werden, können Sie möglicherweise nicht auf alle oder Teile unserer
              Dienste zugreifen. Durch die Nutzung unserer Dienste erklären Sie sich mit der
              Verwendung von Cookies und der Verarbeitung der durch diese Cookies gesammelten
              persönlichen Daten in Übereinstimmung mit dieser Datenschutzrichtlinie einverstanden.
              Sie können Ihre Zustimmung jederzeit widerrufen, indem Sie platzierte Cookies löschen
              und Cookies in Ihrem Browser deaktivieren, oder wie unten erklärt. Sie können die
              Einstellungen Ihres Browsers ändern, um Cookies zu blockieren oder Sie zu
              benachrichtigen, wenn Sie ein Cookie erhalten, Cookies löschen oder unsere Dienste
              unter Verwendung der anonymen Nutzungseinstellung Ihres Browsers durchsuchen. Bitte
              lesen Sie in den Anweisungen Ihres Browsers oder in der Hilfe nach, wie Sie Ihre
              Browsereinstellungen anpassen oder ändern können. Wenn Sie mit der Verwendung von
              Cookies oder ähnlichen Technologien, die Informationen auf Ihrem Gerät speichern,
              nicht einverstanden sind, sollten Sie Ihre Browsereinstellungen entsprechend ändern.
              Sie sollten sich darüber im Klaren sein, dass einige Funktionen unserer Dienste
              möglicherweise nicht richtig funktionieren, wenn Sie keine Cookies akzeptieren. Soweit
              dies nach geltendem Recht erforderlich ist, werden Sie um Ihre Zustimmung zu
              bestimmten Cookies und ähnlichen Technologien gebeten, bevor wir diese auf Ihrem
              Computer oder einem anderen Gerät verwenden oder installieren.
            </p>
            <p>
              <b>Ihre europäischen Datenschutzrechte.</b> Wenn Sie sich im EWR oder im Vereinigten
              Königreich befinden, haben Sie die unten beschriebenen zusätzlichen Rechte.
            </p>
            <ul style={{ listStyleType: 'disc' }}>
              <li>
                <p>
                  Sie haben das Recht, Zugang zu den von uns über Sie gespeicherten
                  personenbezogenen Daten zu verlangen, Ihre personenbezogenen Daten zu
                  aktualisieren und Ungenauigkeiten zu berichtigen, die Verarbeitung Ihrer
                  personenbezogenen Daten einzuschränken oder ihr zu widersprechen, Ihre
                  personenbezogenen Daten gegebenenfalls anonymisieren oder löschen zu lassen oder
                  Ihr Recht auf Datenübertragbarkeit auszuüben, um Ihre personenbezogenen Daten
                  problemlos an ein anderes Unternehmen zu übertragen. Sie haben auch das Recht,
                  eine Beschwerde bei einer Aufsichtsbehörde einzureichen, auch in dem Land, in dem
                  Sie wohnen, arbeiten oder in dem ein Vorfall stattgefunden hat.
                </p>
              </li>
              <li>
                <p>
                  Sie können Ihre Einwilligung in die Verarbeitung Ihrer personenbezogenen Daten
                  jederzeit und kostenlos widerrufen. Wir werden Ihre Präferenzen für die Zukunft
                  übernehmen und dies wird die Rechtmäßigkeit der Verarbeitung vor dem Widerruf
                  Ihrer Zustimmung nicht beeinträchtigen.
                </p>
              </li>
            </ul>
            <p>
              Sie können diese Rechte ausüben, indem Sie sich über die Kontaktdaten am Ende dieser
              Datenschutzrichtlinie an uns wenden. Bevor wir Ihre Anfrage erfüllen, können wir Sie
              bitten, angemessene Informationen zur Überprüfung Ihrer Identität bereitzustellen.
              Bitte beachten Sie, dass es für jedes dieser Rechte Ausnahmen und Einschränkungen gibt
              und dass wir, obwohl alle von Ihnen vorgenommenen Änderungen sofort oder innerhalb
              eines angemessenen Zeitraums in den Datenbanken der aktiven Benutzer wiedergegeben
              werden, personenbezogene Daten für Sicherungen, Archivierung, Verhinderung von Betrug
              und Missbrauch, Analysen, Erfüllung rechtlicher Verpflichtungen oder in Fällen, in
              denen wir aus anderen Gründen der Meinung sind, dass wir einen legitimen Grund dafür
              haben, aufbewahren können.
            </p>

            <p>
              <b>Einwohner von Kalifornien.</b> Wenn Sie in Kalifornien ansässig sind, können Sie
              sich in unserer Datenschutzerklärung{' '}
              <a href="/ccpa">für in Kalifornien ansässige Personen</a> über Ihre Datenschutzrechte
              und -möglichkeiten nach kalifornischem Recht informieren.
            </p>
            <p>
              <b>Einwohner von Nevada.</b> Wenn Sie in Nevada ansässig sind, haben Sie das Recht,
              dem Verkauf bestimmter persönlicher Daten an Dritte zu widersprechen, die
              beabsichtigen, diese persönlichen Daten zu lizenzieren oder zu verkaufen. Sie können
              dieses Recht ausüben, indem Sie uns unter{' '}
              <a href="mailto:info@quillbot.com"> info@quillbot.com</a> mit der Betreffzeile „Nevada
              Do Not Sell Request“ kontaktieren und uns Ihren Namen und die mit Ihrem Konto
              verbundene E- Mail-Adresse mitteilen. Bitte beachten Sie, dass wir Ihre persönlichen
              Daten derzeit nicht verkaufen, wie dies in Nevada Revised Statutes Chapter 603A
              definiert ist.
            </p>
          </p>
          <h3>
            <u>DRITTE PARTEIEN</u>
          </h3>
          <p>
            Unsere Dienste können Links zu anderen Websites, Produkten oder Diensten enthalten, die
            wir nicht besitzen oder betreiben (<b>„Dienste Dritter“</b>). Wir sind nicht
            verantwortlich für die Datenschutzpraktiken dieser Drittanbieterdienste. Bitte beachten
            Sie, dass diese Datenschutzrichtlinie nicht für Ihre Aktivitäten auf diesen
            Drittdiensten oder für Informationen gilt, die Sie diesen Drittdiensten zur Verfügung
            stellen. Wir empfehlen Ihnen, die Datenschutzrichtlinien dieser Drittanbieterdienste zu
            lesen.
          </p>
          <h3>
            <u>AUFBEWAHRUNG</u>
          </h3>
          <p>
            Wir ergreifen Maßnahmen, um Ihre personenbezogenen Daten zu löschen oder in einer Form
            aufzubewahren, die Ihre Identifizierung nicht zulässt, wenn Ihre personenbezogenen Daten
            für die Zwecke, für die wir sie verarbeiten, nicht mehr erforderlich sind, es sei denn,
            wir sind gesetzlich verpflichtet, Ihre personenbezogenen Daten für einen längeren
            Zeitraum aufzubewahren. Bei der Festlegung des spezifischen Aufbewahrungszeitraums
            berücksichtigen wir verschiedene Faktoren, wie z. B. die Art der für Sie erbrachten
            Dienstleistung, die Art und Dauer unserer Beziehung zu Ihnen sowie gesetzlich
            vorgeschriebene Aufbewahrungszeiträume und Verjährungsfristen
          </p>
          <h3>
            <u>SICHERHEIT</u>
          </h3>
          <p>
            Wir bemühen uns in angemessener Weise um den Schutz Ihrer persönlichen Daten, indem wir
            physische und elektronische Sicherheitsvorkehrungen treffen, um die Sicherheit der von
            uns verwalteten persönlichen Daten zu verbessern. Da jedoch keine elektronische
            Übertragung oder Speicherung von Informationen völlig sicher sein kann, können wir keine
            Garantie für die Sicherheit oder den Schutz Ihrer personenbezogenen Daten geben.
          </p>
          <h3>
            <u>NTERNATIONALE BESUCHER</u>
          </h3>
          <p>
            Unsere Dienste werden in den Vereinigten Staaten gehostet und sind für Besucher in den
            Vereinigten Staaten bestimmt. Wenn Sie unsere Dienste aus dem EWR, dem Vereinigten
            Königreich oder anderen Regionen der Welt nutzen, in denen die Gesetze zur
            Datenerfassung und -nutzung von den US-amerikanischen Gesetzen abweichen können,
            beachten Sie bitte, dass Sie Ihre persönlichen Daten außerhalb dieser Regionen zur
            Speicherung und Verarbeitung in die Vereinigten Staaten übertragen. Wir können
            personenbezogene Daten aus dem EWR oder dem Vereinigten Königreich in die Vereinigten
            Staaten übertragen, wenn dies für die Erbringung der von Ihnen angeforderten
            Dienstleistungen erforderlich ist oder wenn Sie Ihre Zustimmung erteilt haben. Außerdem
            können wir Ihre persönlichen Daten in Verbindung mit der Speicherung und Verarbeitung
            von Daten, der Erfüllung Ihrer Anfragen und dem Betrieb unserer Dienste aus den USA in
            andere Länder oder Regionen übertragen. Indem Sie Informationen, einschließlich
            personenbezogener Daten, auf unseren Diensten oder an unsere Dienste übermitteln,
            stimmen Sie einer solchen Übertragung, Speicherung und Verarbeitung zu. Um weitere
            Informationen zu den Übertragungen zu erhalten, setzen Sie sich bitte mit uns in
            Verbindung, indem Sie die nachstehenden Kontaktinformationen verwenden.
          </p>
          <h3>
            <u>PRIVATSPHÄRE VON KINDERN</u>
          </h3>
          <p>
            Wir erheben, pflegen oder verwenden nicht wissentlich persönliche Daten von Kindern
            unter 13 Jahren, und kein Teil unserer Dienste ist an Kinder gerichtet. Wenn Sie
            erfahren, dass ein Kind uns unter Verstoß gegen diese Datenschutzrichtlinie persönliche
            Daten zur Verfügung gestellt hat, informieren Sie uns bitte unter{' '}
            <a href="mailto:info@quillbot.com"> info@quillbot.com</a>.
          </p>
          <h3>
            <u>ÄNDERUNGEN AN DIESER DATENSCHUTZRICHTLINIE</u>
          </h3>
          <p>
            Wir werden alle Änderungen an der Datenschutzrichtlinie auf dieser Seite
            veröffentlichen, und die überarbeitete Version tritt in Kraft, sobald sie veröffentlicht
            wird. Wenn wir die Art und Weise, wie wir persönliche Daten, die wir zuvor über unsere
            Dienste von Ihnen gesammelt haben, verwenden oder weitergeben, wesentlich ändern, werden
            wir versuchen, Sie über unsere Dienste, per E-Mail oder auf andere Weise zu informieren.
          </p>
          <h3>
            <u>KONTAKTINFORMATIONEN</u>
          </h3>
          <p>
            <p>
              Wenn Sie Fragen, Kommentare oder Bedenken bezüglich unserer Verarbeitung haben, senden
              Sie uns bitte eine E-Mail an{' '}
              <a href="mailto:info@quillbot.com"> info@quillbot.com </a>
              oder schreiben Sie uns an:
            </p>
            <p style={{ marginLeft: '10%' }}>
              QuillBot (Course Hero), LLC
              <br />
              200 E. Randolph St. (Aon Center) Suite 5215
              <br />
              Chicago, Illinois 60601
            </p>
            <p>
              Einzelpersonen und Datenschutzaufsichtsbehörden in der Europäischen Union (<b>„EU“</b>
              ) und im Vereinigten Königreich können sich gemäß Artikel 27 DSGVO an unsere
              Datenschutzbeauftragten wenden:
            </p>
            <p style={{ marginLeft: '10%' }}>
              EU: DP-Dock GmbH, Attn: QuillBot, Ballindamm 39, 20095 Hamburg, Germany <br />
              UK: DP Data Protection Services UK Ltd., Attn: QuillBot, 16 Great Queen Street, Covent
              Garden, London, WC2B 5AH, United Kingdom
              <br />
              <a href="https://www.dp-dock.com" rel="noopener noreferrer" target="_blank">
                {' '}
                www.dp-dock.com
              </a>{' '}
              <br />
              <a href="mailto:quillbot@gdpr-rep.com"> quillbot@gdpr-rep.com</a>
            </p>
          </p>
        </div>
      </div>
      <Dialog open={showModal} style={{ display: 'relative' }} onClose={() => setShowModal(false)}>
        <IconButton
          style={{ position: 'absolute', top: 0, right: 0 }}
          onClick={() => setShowModal(false)}
          size="large"
        >
          <CloseOutlined />
        </IconButton>
        <DialogTitle id="disable-user-tracking" style={{ fontWeight: 600, fontSize: '20px' }}>
          Disable Tracking
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You&#39;re about to disable all future tracking events. Please note some
            features/functionalities may not work properly as a result.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => openModal()}>CONTINUE</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default PrivacyPageDE;
